import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  effect,
  ElementRef,
  input,
  output,
  signal,
  TemplateRef,
  viewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerSize } from '../../../loading-indicators';

@Component({
  selector: 'f-custom-suggester',
  templateUrl: './custom-suggester.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireflyCustomSuggesterComponent {
  readonly suggesterCustomTemplate = contentChild<TemplateRef<unknown> | null>('fSuggesterCustomTemplate');
  readonly suggesterIconTemplate = contentChild<TemplateRef<unknown> | null>('fSuggesterIconTemplate');
  readonly dropdown = viewChild.required<NgbDropdown>('dropdown');
  readonly inputElement = viewChild.required<ElementRef<HTMLInputElement>>('inputElement');

  showLoadedTemplate = input<boolean, boolean>(false, {
    transform: value => {
      this._toggleDropdown.set(value);
      return value;
    }
  });
  placeholder = input<string>('');
  inputValue = input<FormControl>(new FormControl());
  placement = input<string>('bottom top');
  loading = input<boolean>(false);

  focus = output<void>();
  reset = output<void>();
  enter = output<void>();

  spinnerSizes = SpinnerSize;

  private _toggleDropdown = signal<boolean>(false);

  constructor() {
    effect(onCleanup => {
      const isOpen = this._toggleDropdown();
      const loadingState = this.loading();
      const timeoutId = setTimeout(() => {
        const dropdownElement = this.dropdown();
        dropdownElement && (isOpen && !loadingState ? dropdownElement.open() : dropdownElement.close());
      }, 0);
      onCleanup(() => clearTimeout(timeoutId));
    });
  }

  onFocus(): void {
    if (this.showLoadedTemplate()) {
      this._toggleDropdown.set(true);
    }
    this.focus.emit();
  }

  clear(): void {
    this.inputValue().setValue('');
    this.reset.emit();
  }

  onEnter(): void {
    this.enter.emit();
  }

  OnSuggesterOpenChange(event: boolean): void {
    this._toggleDropdown.set(event);
  }
}
